import { render } from "./ReflectionList.vue?vue&type=template&id=345f6afd"
import script from "./ReflectionList.vue?vue&type=script&lang=js"
export * from "./ReflectionList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__